import React from "react";

const LEVEL_CLASS = {
  LOW: "bg-green-100 text-green-800",
  MEDIUM: "bg-yellow-100 text-yellow-800",
  HIGH: "bg-orange-100 text-orange-800",
  CRITICAL: "bg-red-100 text-red-800",
};
const DECISION_LABEL = {
  ALLOW: "Allowed",
  STEP_UP: "Extra verification (MFA) required",
  BLOCK: "Blocked",
};
const REASON_LABEL = {
  // login
  NEW_IP: "New IP address",
  NEW_COUNTRY: "New country",
  NEW_DEVICE: "New device",
  UNUSUAL_LOGIN_TIME: "Unusual login time",
  IMPOSSIBLE_TRAVEL: "Impossible travel",
  MULTIPLE_FAILED_LOGINS: "Multiple failed logins",
  MULTIPLE_ACCOUNTS_TARGETED: "Multiple accounts targeted from this IP",
  VPN_OR_PROXY: "VPN / proxy / hosting network",
  TOR: "Tor network",
  MULTIPLE_CORRELATED_SIGNALS: "Several unusual signals together",
  // payroll
  SENSITIVE_OPERATION: "Sensitive payroll operation",
  MANUAL_MONEY_EDIT: "Pay figures edited by hand",
  FORCED_OVERRIDE: "Overrode figures that came from Everee",
  DELETE_SYNCED_PAYMENT: "Deleted a paid (synced) payroll record",
  LARGE_PAY_RATE_INCREASE: "Large pay-rate increase",
  EXCESSIVE_HOURS: "Unusually high timesheet hours",
  HIGH_TIMESHEET_VOLUME: "Large timesheet batch",
  RISKY_LOGIN_SESSION: "Session started from a risky login",
  IP_CHANGED_SINCE_LOGIN: "Network changed since login",
  UNUSUAL_ACTION_TIME: "Unusual time for this user",
  BURST_ACTIVITY: "Many repeated actions in a short time",
  BANK_CHANGE_BEFORE_PAYOUT: "Bank account changed shortly before payout",
  POLICY_REQUIRES_MFA: "Policy requires MFA for this action",
};
const humanize = (s) =>
  String(s).toLowerCase().split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

/** Old audit records (no metadata.security) return false, so nothing extra is rendered. */
export const hasSecurityInfo = (item) => {
  const s = item?.metadata?.security;
  return !!(s && (s.riskLevel || s.engineStatus === "UNAVAILABLE"));
};

const Cell = ({ label, children }) => (
  <div className="p-4 bg-white rounded-md border border-slate-200">
    <strong className="text-sm">{label}:</strong>
    <div className="mt-1 font-medium text-sm break-words">{children}</div>
  </div>
);

const AuditLogSecurity = ({ item }) => {
  if (!hasSecurityInfo(item)) return null;
  const s = item.metadata.security;
  const c = s.context || {};
  const place = [c.city, c.regionName, c.countryCode].filter(Boolean).join(", ");
  const reasons = Array.isArray(s.reasons) ? s.reasons : [];
  const payroll = item.metadata?.payroll;

  return (
    <div className="col-span-2 p-4 bg-slate-100 rounded-md">
      <h4 className="font-semibold mb-3">Security Risk</h4>
      {s.engineStatus === "UNAVAILABLE" && !s.riskLevel ? (
        <p className="text-sm text-yellow-800">
          Risk analysis was unavailable for this action (the action itself was not blocked by it).
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {payroll?.op && (
            <Cell label="Operation">
              {humanize(payroll.op)}
              {payroll.field && <span className="block text-xs text-gray-500 mt-1">Field: {payroll.field}</span>}
            </Cell>
          )}
          <Cell label="Risk Score">{s.riskScore}</Cell>
          <Cell label="Risk Level">
            <span className={`inline-flex px-3 py-1 rounded-full text-sm ${LEVEL_CLASS[s.riskLevel] || "bg-gray-100 text-gray-800"}`}>
              {humanize(s.riskLevel)}
            </span>
          </Cell>
          <Cell label="Decision">
            {DECISION_LABEL[s.decision] || humanize(s.decision || "-")}
            {s.stepUpVerified && (
              <span className="block text-xs text-green-700 mt-1">MFA was verified for this action.</span>
            )}
            {s.stepUpRequired && (
              <span className="block text-xs text-gray-500 mt-1">MFA was requested; this attempt was not completed.</span>
            )}
            {s.stepUpUnavailable && (
              <span className="block text-xs text-gray-500 mt-1">
                MFA is not enabled on this account, so verification could not be requested.
              </span>
            )}
          </Cell>
          <Cell label="Risk Reasons">
            {reasons.length ? (
              <ul className="list-disc ml-4">
                {reasons.map((r) => <li key={r}>{REASON_LABEL[r] || humanize(r)}</li>)}
              </ul>
            ) : "None"}
          </Cell>
          {s.historyStatus && s.historyStatus !== "ESTABLISHED" && (
            <Cell label="History">
              {s.historyStatus === "NONE" ? "No prior logins to compare" : "Limited prior logins to compare"}
            </Cell>
          )}
        </div>
      )}
      {(place || c.deviceHash || c.deviceProvided === false) && (
        <div className="grid grid-cols-2 gap-3 mt-3">
          {place && <Cell label="Location">{place}</Cell>}
          <Cell label="Device">
            {c.deviceHash ? `ID ${String(c.deviceHash).slice(0, 8)}…` : "Not provided"}
          </Cell>
          {(c.isVpnOrProxy || c.isTor) && (
            <Cell label="Network">{c.isTor ? "Tor" : "VPN / proxy"}</Cell>
          )}
        </div>
      )}
      {item.metadata?.requestId && (
        <p className="text-xs text-gray-500 mt-3 break-all">Request ID: {item.metadata.requestId}</p>
      )}
    </div>
  );
};

export default AuditLogSecurity;





// import React from "react";

// const LEVEL_CLASS = {
//   LOW: "bg-green-100 text-green-800",
//   MEDIUM: "bg-yellow-100 text-yellow-800",
//   HIGH: "bg-orange-100 text-orange-800",
//   CRITICAL: "bg-red-100 text-red-800",
// };
// const DECISION_LABEL = {
//   ALLOW: "Allowed",
//   STEP_UP: "Extra verification (MFA) required",
//   BLOCK: "Blocked",
// };
// const REASON_LABEL = {
//   NEW_IP: "New IP address",
//   NEW_COUNTRY: "New country",
//   NEW_DEVICE: "New device",
//   UNUSUAL_LOGIN_TIME: "Unusual login time",
//   IMPOSSIBLE_TRAVEL: "Impossible travel",
//   MULTIPLE_FAILED_LOGINS: "Multiple failed logins",
//   MULTIPLE_ACCOUNTS_TARGETED: "Multiple accounts targeted from this IP",
//   VPN_OR_PROXY: "VPN / proxy / hosting network",
//   TOR: "Tor network",
//   MULTIPLE_CORRELATED_SIGNALS: "Several unusual signals together",
// };
// const humanize = (s) =>
//   String(s).toLowerCase().split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

// /** Old audit records (no metadata.security) return false, so nothing extra is rendered. */
// export const hasSecurityInfo = (item) => {
//   const s = item?.metadata?.security;
//   return !!(s && (s.riskLevel || s.engineStatus === "UNAVAILABLE"));
// };

// const Cell = ({ label, children }) => (
//   <div className="p-4 bg-white rounded-md border border-slate-200">
//     <strong className="text-sm">{label}:</strong>
//     <div className="mt-1 font-medium text-sm break-words">{children}</div>
//   </div>
// );

// const AuditLogSecurity = ({ item }) => {
//   if (!hasSecurityInfo(item)) return null;
//   const s = item.metadata.security;
//   const c = s.context || {};
//   const place = [c.city, c.regionName, c.countryCode].filter(Boolean).join(", ");
//   const reasons = Array.isArray(s.reasons) ? s.reasons : [];

//   return (
//     <div className="col-span-2 p-4 bg-slate-100 rounded-md">
//       <h4 className="font-semibold mb-3">Security Risk</h4>
//       {s.engineStatus === "UNAVAILABLE" && !s.riskLevel ? (
//         <p className="text-sm text-yellow-800">
//           Risk analysis was unavailable for this login (the login itself was not blocked by it).
//         </p>
//       ) : (
//         <div className="grid grid-cols-2 gap-3">
//           <Cell label="Risk Score">{s.riskScore}</Cell>
//           <Cell label="Risk Level">
//             <span className={`inline-flex px-3 py-1 rounded-full text-sm ${LEVEL_CLASS[s.riskLevel] || "bg-gray-100 text-gray-800"}`}>
//               {humanize(s.riskLevel)}
//             </span>
//           </Cell>
//           <Cell label="Decision">
//             {DECISION_LABEL[s.decision] || humanize(s.decision || "-")}
//             {s.stepUpUnavailable && (
//               <span className="block text-xs text-gray-500 mt-1">
//                 MFA is not enabled on this account, so verification could not be requested.
//               </span>
//             )}
//           </Cell>
//           <Cell label="Risk Reasons">
//             {reasons.length ? (
//               <ul className="list-disc ml-4">
//                 {reasons.map((r) => <li key={r}>{REASON_LABEL[r] || humanize(r)}</li>)}
//               </ul>
//             ) : "None"}
//           </Cell>
//           {s.historyStatus && s.historyStatus !== "ESTABLISHED" && (
//             <Cell label="History">
//               {s.historyStatus === "NONE" ? "No prior logins to compare" : "Limited prior logins to compare"}
//             </Cell>
//           )}
//         </div>
//       )}
//       {(place || c.deviceHash || c.deviceProvided === false) && (
//         <div className="grid grid-cols-2 gap-3 mt-3">
//           {place && <Cell label="Location">{place}</Cell>}
//           <Cell label="Device">
//             {c.deviceHash ? `ID ${String(c.deviceHash).slice(0, 8)}…` : "Not provided"}
//           </Cell>
//           {(c.isVpnOrProxy || c.isTor) && (
//             <Cell label="Network">{c.isTor ? "Tor" : "VPN / proxy"}</Cell>
//           )}
//         </div>
//       )}
//       {item.metadata?.requestId && (
//         <p className="text-xs text-gray-500 mt-3 break-all">Request ID: {item.metadata.requestId}</p>
//       )}
//     </div>
//   );
// };

// export default AuditLogSecurity;